import './App.css';
import ro from './assets/ro.png';
import rok from './assets/rok.png';
import roko from './assets/roko.png';
import rokob from './assets/rokob.png';

function App() {
  return (
    <div className="App">
      <header className="header">
        <h1>Rokoba</h1>
        <p className="tagline">Master Japanese Vocabulary, One Word at a Time!</p>
      </header>

      <main className="main-content">
        <section className="app-description">
          <p className="intro">
            Learning Japanese has never been easier! Our app helps you learn 6 new Japanese words each day, 
            complete with meanings and pronunciations delivered directly to your device. No need to open the app — 
            you'll receive notifications that allow you to learn effortlessly, anywhere, anytime. Perfect for beginners 
            and advanced learners alike, this app makes language learning seamless and fun.
          </p>
        </section>

        <section className="features">
          <h2>Features</h2>
          <ul>
            <li><strong>Daily Word Notifications:</strong> Receive six new Japanese words every day, including their meanings and audio pronunciations, directly in your notifications.</li>
            <li><strong>Learn Without Opening the App:</strong> View word meanings and pronunciations in the notification itself — no need to open the app!</li>
            <li><strong>Large Vocabulary Library:</strong> Access over 10,000 words, from basic to advanced, all designed to improve your fluency.</li>
            <li><strong>Pronunciation Guides:</strong> Hear the correct pronunciation for each word, helping you master Japanese pronunciation.</li>
            <li><strong>User-Friendly Design:</strong> A clean, intuitive interface that makes learning enjoyable and easy.</li>
          </ul>
          <p className="closing">
            Whether you're preparing for the JLPT or just interested in learning Japanese, this app provides the perfect 
            way to expand your vocabulary, one word at a time!
          </p>
        </section>

        <section className="app-previews">
          <h2>App Previews</h2>
          <div className="preview-grid">
            <img src={ro} alt="Rokoba app preview 1" className="preview-image" />
            <img src={rok} alt="Rokoba app preview 2" className="preview-image" />
            <img src={roko} alt="Rokoba app preview 3" className="preview-image" />
            <img src={rokob} alt="Rokoba app preview 4" className="preview-image" />
          </div>
        </section>

        <section className="availability">
          <p><strong>Available on:</strong> iOS (Paid App)</p>
          <p><strong>Coming soon:</strong> Android</p>
        </section>
      </main>

      <footer className="footer">
        <h3>Developer Information</h3>
        <div className="developer-info">
          <p><strong>Name:</strong> Nishan Baral</p>
          <p><strong>Email:</strong> <a href="mailto:baralnishan987@gmail.com">baralnishan987@gmail.com</a></p>
          <p><strong>Address:</strong> Yokohama, Japan</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
